module.exports = __webpack_public_path__ + "static/media/deatult_leopard_low_size.5d142d5c.jpg";